var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 * 组织架构tab 数据列表
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import UserSelectionContext from '../context';
import TabPaneListItem from './TabPaneListItem';
import { OrgType, } from '../types';
import Loading from '../../Loading';
import { DeptCrumb } from './DeptCrumb';
import { getDeptPositionDesc, mapEBookDeptInfo, mapEBookDeptUserInfo } from '../common';
import { Empty } from 'antd';
import SelectAll from './SelectAll';
import arrowRightIcon from '../../images/app_ic_arrow_right.png';
function OrgDeptList(props) {
    var _a = React.useContext(UserSelectionContext), t = _a.t, canSelectDept = _a.canSelectDept, chooseOnlyDepart = _a.chooseOnlyDepart, frozenIds = _a.frozenIds;
    var onDeptClick = props.onDeptClick, result = props.result, ebookSubDeptInfoList = props.ebookSubDeptInfoList, onItemSelect = props.onItemSelect;
    var getExtraPart = useCallback(function (deptItem) {
        if (chooseOnlyDepart || canSelectDept) {
            return (React.createElement("div", { className: deptItem.checked
                    ? "focus-user-selection-dept selection-dept-disabled"
                    : 'focus-user-selection-dept', onClick: function (event) {
                    event.stopPropagation();
                    if (!deptItem.checked) {
                        onDeptClick({ id: deptItem.deptId });
                    }
                } },
                React.createElement("span", { className: "focus-user-selection-dept-arrow org-dept-arrow " },
                    React.createElement("img", { src: arrowRightIcon, alt: "" }))));
        }
        return (React.createElement("span", { className: "focus-user-selection-dept-arrow", onClick: function (event) {
                onDeptClick({ id: deptItem.deptId });
                event.stopPropagation();
            } },
            React.createElement("img", { src: arrowRightIcon, alt: "" })));
    }, [canSelectDept, chooseOnlyDepart, onDeptClick]);
    var getDisabled = useCallback(function (item) {
        return frozenIds.findIndex(function (id) { return id === item.deptId; }) >= 0;
    }, [frozenIds]);
    return (React.createElement("div", { className: "" }, ebookSubDeptInfoList.map(function (item) {
        var deptId = item.deptId;
        return (React.createElement(TabPaneListItem, { disabled: getDisabled(item), key: deptId, data: item, checkable: chooseOnlyDepart || canSelectDept, extra: getExtraPart(item), onCheckChange: function (deptItem) {
                onItemSelect(deptItem);
            }, onClick: function () {
                if (!canSelectDept || !chooseOnlyDepart) {
                    onDeptClick({ id: deptId });
                }
            } }));
    })));
}
function OrgUserList(props) {
    var _a = React.useContext(UserSelectionContext), frozenIds = _a.frozenIds, defaultUserAvatar = _a.defaultUserAvatar, single = _a.single;
    var dataList = props.dataList, onItemSelect = props.onItemSelect;
    var getDisabled = useCallback(function (item) {
        return frozenIds.findIndex(function (id) { return id === item.id; }) >= 0;
    }, [frozenIds]);
    return (React.createElement("div", null, dataList.map(function (item) {
        return (React.createElement(TabPaneListItem, { single: single, disabled: getDisabled(item), key: item.id, defualtImg: defaultUserAvatar, data: item, checkable: true, onCheckChange: function (item) {
                onItemSelect(__assign(__assign({}, item), { desc: getDeptPositionDesc({
                        deptName: item.deptName || '',
                        titleName: item.titleName || item.positionName || '',
                        unitName: (item === null || item === void 0 ? void 0 : item.unitName) || '',
                        userType: item.userType,
                    }) }));
            } }));
    })));
}
// eslint-disable-next-line complexity
export default function OrgList(props) {
    var _this = this;
    var _a = React.useContext(UserSelectionContext), t = _a.t, currentUser = _a.currentUser, frozenIds = _a.frozenIds, dataListFilter = _a.dataListFilter, canSelectDept = _a.canSelectDept, chooseOnlyDepart = _a.chooseOnlyDepart;
    var result = props.result, onItemCheck = props.onItemCheck, onGetEBookDeptInfo = props.onGetEBookDeptInfo, onGetEBookOrgInfo = props.onGetEBookOrgInfo, orgId = props.orgId, orgType = props.orgType, jumpCurrentOrgItem = props.jumpCurrentOrgItem;
    var _b = useState(null), eBookDeptInfo = _b[0], setEBookDeptInfo = _b[1];
    var _c = useState([]), simpleDeptInfoList = _c[0], setSimpleDeptInfoList = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(null), err = _e[0], setErr = _e[1];
    var nodata = chooseOnlyDepart
        ? !((eBookDeptInfo || {}).ebookSubDeptInfoList || []).length
        : !((eBookDeptInfo || {}).ebookSubDeptInfoList || []).length &&
            !((eBookDeptInfo || {}).ebookInfoResList || []).length;
    var getParams = useCallback(function (deptId) {
        if (orgType === OrgType.virtual) {
            return {
                appId: currentUser.app || 'gwork',
                orgId: deptId || orgId || '',
                displaySubDept: true,
            };
        }
        return { deptId: deptId || orgId, displaySubDept: true };
    }, [orgType, currentUser, orgId]);
    var fetchDataList = React.useCallback(function (deptId) {
        if (!onGetEBookDeptInfo) {
            return;
        }
        if (orgType === OrgType.virtual && !onGetEBookOrgInfo) {
            return;
        }
        setLoading(true);
        var fn = orgType === OrgType.virtual ? onGetEBookOrgInfo : onGetEBookDeptInfo;
        fn(getParams(deptId))
            .then(function (deptResult) {
            setErr(null);
            setEBookDeptInfo(deptResult);
            setSimpleDeptInfoList(deptResult.simpleDeptInfoList.map(function (item) {
                return __assign(__assign({}, item), { id: item.deptId, name: item.deptName });
            }) || []);
        })
            .catch(function (e) {
            setErr(e);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [onGetEBookDeptInfo, onGetEBookOrgInfo, orgType, getParams] // eslint-disable-line
    );
    var deptClick = useCallback(function (_a) {
        var id = _a.id;
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // 控制点击面包悄部门和列表项部门时的loading
                        setEBookDeptInfo(null);
                        return [4 /*yield*/, fetchDataList(id)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }, [fetchDataList]);
    useEffect(function () {
        if (jumpCurrentOrgItem) {
            deptClick({ id: jumpCurrentOrgItem.deptId });
            return;
        }
        fetchDataList();
    }, [deptClick, fetchDataList, jumpCurrentOrgItem]);
    var dataList = useMemo(function () {
        if (!eBookDeptInfo) {
            return [];
        }
        var list = mapEBookDeptUserInfo(eBookDeptInfo, result, frozenIds);
        if (dataListFilter) {
            list = list.filter(dataListFilter);
        }
        return list;
    }, [eBookDeptInfo, frozenIds, dataListFilter, result]);
    var deptList = useMemo(function () {
        return mapEBookDeptInfo((eBookDeptInfo || {}).ebookSubDeptInfoList || [], result, chooseOnlyDepart || canSelectDept);
    }, [eBookDeptInfo, result, chooseOnlyDepart, canSelectDept]);
    var selectedList = useMemo(function () {
        return chooseOnlyDepart || canSelectDept ? __spreadArrays(dataList, deptList) || [] : dataList;
    }, [canSelectDept, chooseOnlyDepart, dataList, deptList]);
    var comp;
    if (loading) {
        comp = React.createElement(Loading, { style: { height: '100%' } });
    }
    else if (err) {
        comp = React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" });
    }
    else {
        comp = (React.createElement(React.Fragment, null,
            simpleDeptInfoList.length > 0 && (React.createElement(DeptCrumb, { data: simpleDeptInfoList, onItemClick: deptClick })),
            React.createElement("div", { className: "dept-user-container" },
                !chooseOnlyDepart && (React.createElement(SelectAll, { dataList: selectedList || [], result: result })),
                (eBookDeptInfo || {}).ebookInfoResList && !chooseOnlyDepart && (React.createElement(OrgUserList, { onItemSelect: function (user) {
                        onItemCheck(user);
                    }, dataList: dataList || [] })),
                (eBookDeptInfo || {}).ebookSubDeptInfoList && (React.createElement(OrgDeptList, { onItemSelect: function (dept) {
                        onItemCheck(dept);
                    }, result: result, onDeptClick: deptClick, ebookSubDeptInfoList: deptList })),
                nodata && (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })))));
    }
    return React.createElement("div", { className: "crumb-dept-user-container" }, comp);
}
//# sourceMappingURL=OrgList.js.map